import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Admins = {
    agregarAdmin: async (data) => {
        let url = url_json + "/admin"
        let body = {
            correo: data.correo,
            password: data.password,
            tipo: data.tipo,
            tipoMostrar: data.tipoMostrar
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Administrador agregado correctamente' ,
              'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar el administrador: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerAdmins: async () => {
        let url = url_json + "/admin"
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerUnAdmin: async id => {
        let url = url_json + "/admin/" + id
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarAdmin: async (data, id) => {
        let url = url_json + "/admin/" + id;
        // Solo se mandan los campos con valor: la contraseña vacía no se toca y el tipo solo lo cambia un general
        let body = {};
        ['correo', 'tipoMostrar', 'tipo', 'password'].forEach(campo => {
            if (data[campo] !== undefined && data[campo] !== '') body[campo] = data[campo];
        });
        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Administrador modificado correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar el administrador: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    eliminarAdmin: async id => {
        let url = url_json + "/admin/delete/" + id;
        let request = {
            method: 'PATCH',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Eliminación exitosa!',
                'Administrador eliminado correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo eliminar el administrador: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    login: async (correo, password) => {
        let url = url_json + "/admin/login"
        let body = {
            correo,
            password
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        if (response.ok && json.token) {
            localStorage.setItem('caav_token', json.token);
        }
        return { success: response.ok, data: json.data, code: json.message };
    }
}

export default Admins;
